import React from "react";

const CampaignReceives = ({ currencySymbol, campaignAmountTotal }) => (
  <div>
    <span className="fees__donation-form-fee">
      <p>Campaign receives:</p>
      <p className="fees__donation-form-amounts fees__donation-form-amounts--campaign-recieves">
        {currencySymbol}
        {campaignAmountTotal}
      </p>
    </span>
  </div>
);

export default CampaignReceives;
